import { render, staticRenderFns } from "./shelves.vue?vue&type=template&id=76fa6f99&scoped=true"
import script from "./shelves.vue?vue&type=script&lang=js"
export * from "./shelves.vue?vue&type=script&lang=js"
import style0 from "./shelves.vue?vue&type=style&index=0&id=76fa6f99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa6f99",
  null
  
)

export default component.exports